module.exports = __webpack_public_path__ + "img/instagram.46070a72.svg";